<div class="cemento-fecha-section">
  <p class="cemento-fecha-section__hint">
    Selecciona la fecha en la que deseas recibir tu pedido o retirarlo en planta, según el tipo de entrega elegido.
  </p>
  <p class="cemento-fecha-section__hint">
    Las fechas disponibles son las marcadas con un cuadro gris.
  </p>
  <app-schedule-datepicker
    [minimumLeadDays]="0"
    [minimumDateIso]="minScheduleDate()"
    [initialSchedule]="initialSchedule()"
    [showSchedules]="false"
    (validChange)="onValidChange($event)">
  </app-schedule-datepicker>
</div>
